<template>
  <footer class="footer footer-black footer-white">
    <div class="container-fluid">
      <div class="row">
        <nav class="footer-nav">
        </nav>
        <div class="credits ml-auto">
          <div class="copyright">
            Coded with
            <i class="fa fa-heart heart"></i> by Mario Lauterbach
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    name: 'main-footer'
  }
</script>
<style>
</style>
